<template>
    <div class="flex border-t border-b -mt-px border-gray-200 draggable bg-white">
        <!-- Draggable handle. -->
        <div class="w-6 flex-shrink-0 self-start py-1.5">
            <div class="w-5 h-5 flex items-center" v-if="!readonly">
                <i class="fa fa-bars fa-fw text-xs text-gray-300 hover:text-gray-400 cursor-move handle"></i>
            </div>
        </div>
        <!-- Type. -->
        <div class="w-1/4 flex">
            <select
                v-if="!readonly"
                class="flex-grow flex-1 m-0.5 mr-1 border shadow-sm rounded-md text-xs px-2 border border-gray-200 p-0.5"
                @input="$emit('changed')"
                v-model="item.type"
            >
                <option value="Labour" v-text="'Labour'"></option>
                <option value="Materials" v-text="'Materials'"></option>
                <option value="Plant" v-text="'Plant'"></option>
            </select>
            <textarea v-else
                      class="text-sm -my-px text-gray-600 px-2 py-1.5 border border-gray-200 resize-none overflow-hidden overflow-x-auto whitespace-nowrap shadow-none relative hover:border hover:border-gray-200 cursor-text"
                      style="cursor:auto !important"
                      rows="1"
                      disabled
                      :value="item.type"
            ></textarea>
        </div>
        <!-- Description. -->
        <div class="flex-grow flex -mx-px bg-white">
            <page-cell
                :use-textarea-readonly="true"
                ref="description"
                :read-only="readonly"
                class="text-sm -my-px px-2 py-1.5 border border-gray-200"
                :placeholder="'Description...'"
                v-model="item.description"
                @input="$emit('changed')"
            ></page-cell>
        </div>
        <!-- Description. -->
        <div class="w-1/4 flex bg-white">
            <page-cell
                ref="quantity"
                class="text-sm -my-px px-2 py-1.5 border border-gray-200"
                :read-only="readonly"
                :use-textarea-readonly="true"
                :placeholder="'Quantity...'"
                v-model="item.quantity"
                @input="$emit('changed')"
            ></page-cell>
        </div>
        <!-- Dropdown. -->
        <div class="w-6 flex-shrink-0 ml-2 self-start py-1.5">
            <ui-dropdown menu-class="p-3 w-48" v-if="!readonly">
                <template #default="{ toggle }">
                    <button @click="toggle"
                            class="w-5 h-5 flex items-center justify-center text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative rounded">
                        <i class="fa fa-ellipsis-h fa-fw"></i>
                    </button>
                </template>
                <template #menu="{ close }">
                    <ui-dropdown-item icon="fas fa-trash" danger @click="$emit('removeItem',item); close()">
                        Remove item
                    </ui-dropdown-item>
                </template>
            </ui-dropdown>
        </div>

    </div>
</template>

<script>

import UiDropdownDivider from "../../ui/UiDropdownDivider.vue";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import UiDropdown from "../../ui/UiDropdown.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import UiSelect from "../../ui/UiSelect.vue";

export default {
    components: {
        UiSelect,
        UiButtonNew, UiDropdown, UiDropdownItem, UiDropdownDivider
    },
    props: {
        item: Object,
        readonly: {type: Boolean, default: false},
    },
    data() {
        return {}
    },
    computed: {},
    methods: {
        save() {

        }
    },
    mounted() {
    }
}
</script>
